import { Component } from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrls: ['./hero-section.component.scss'],
})
export class V2HeroSectionComponent {
  stats = [
    {statKey: 'talentSearchV2.hero.stat1', labelKey: 'talentSearchV2.hero.stat1Label'},
    {statKey: 'talentSearchV2.hero.stat2', labelKey: 'talentSearchV2.hero.stat2Label'},
    {statKey: 'talentSearchV2.hero.stat3', labelKey: 'talentSearchV2.hero.stat3Label'},
    {statKey: 'talentSearchV2.hero.stat4', labelKey: 'talentSearchV2.hero.stat4Label'},
  ];

  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
